module.exports = __webpack_public_path__ + "img/钟表-10.b9b7f6f0.png";